import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Button, Heading, Text } from '@zillow/constellation';
import * as S from './styles';
import { trackEvent } from 'app/shared/utils/analytics/trackEvent';
import { gaEvents } from 'app/shared/constants/AnalyticsConstants';
import MarketTrendsCSEvents from 'app/shared/constants/MarketTrendsCSEvents';

import LazyLoad from 'app/shared/components/LazyLoad';

import IllustrationTruckHome from 'images/zrmUpsell/illustration-truck-home.webp';

import type { State } from 'app/shared/types/State';

interface MarketUpsellProps {
  name: string;
  href: string;
  isSmallScreen: boolean;
}

const MarketUpsell: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<MarketUpsellProps>>> = (
  props,
) => {
  const { name, href, isSmallScreen } = props;
  const user = useSelector((state: State) => state.user);
  const exploreRentals = useCallback(
    () => trackEvent(gaEvents.EXPLORE_RENTALS, { clickstreamEvent: MarketTrendsCSEvents.ExploreRentals({ user }) }),
    [],
  );
  return (
    <S.Card cardType="secondary" padding="md" marginTop="md">
      <LazyLoad>
        <img src={IllustrationTruckHome} alt="Moving truck in front of home" />
      </LazyLoad>
      <S.TextContainer isSmallScreen={isSmallScreen}>
        <Heading level="4" as="h3" fontFamily="serif">
          Rent in {name}
        </Heading>
        <Text as="p">
          We created a seamless online experience for you - from shopping on the largest rental network, to applying, to
          paying rent.
        </Text>
      </S.TextContainer>
      <Button as="a" href={href} onClick={exploreRentals} buttonType="secondary" marginX="xl">
        Explore Rentals
      </Button>
    </S.Card>
  );
};

export default MarketUpsell;
